{
  "name": "chancen-campus",
  "displayName": "ChancenCampus",
  "description": "The ChancenCampus ist the fully intergrated E-Learning Platform of the Chancenwerk e.V.",
  "version": "3.7.0",
  "private": true,
  "type": "module",
  "scripts": {
    "start": "adornis-build project --watch --serve --no-production",
    "update-adornis": "npx npm-check-updates --target greatest @adornis/*",
    "test": "adornis-build project test --no-production",
    "updateSkeleton": "bash -c \"$(curl https://static.adornis.de/scripts/pull-skeleton.sh)\"",
    "switchModule": "bash deploy/module.sh",
    "build": "adornis-build project build --deployPath /app/chancencampus/dist"
  },
  "@adornis/esbuild": {
    "server-path": "./src/server",
    "client-path": "./src/client",
    "print-path": "../src/print-components",
    "node-worker-path": "./src/node-workers",
    "output-path": "dist",
    "listenPort": 3000,
    "nodePort": 3001,
    "hotReloadPort": 3002,
    "inspectPort": 9222
  },
  "license": "ISC"
}
